var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.className, _vm.size],style:(_vm.iconStyle),attrs:{"viewBox":"0 0 24 24"}},[_c('use',_vm._b({class:_vm.light ? 'light' : 'dark'},'use',{ 'xlink:href': `${_vm.iconSvg}#${_vm.iconName}` },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }